<template>
  <div class="hero-title-animation">
    <h6 class="text1">{{ label }}</h6>
    <div class="border-container" ></div>
  </div>
</template>

<script>
export default {
  name: 'HeroTitleAnimation',
  props: {
    label: String,
  }

}
</script>

<style lang="scss">
@import "HeroTitleAnimation.scss";
</style>
